import React, { useMemo, useRef, useState } from 'react'
import {
  Button,
  List,
  ListItem,
  useTheme,
} from "@mui/material"
import { useSelector } from "react-redux"
import POSHeaderContainer from './container'
import posActiveIcon from "assests/point_of_sale_24dp_E8EAED 2.svg"
import posIcon from "assests/Vector.svg"
import ordersIcon from "assests/food_bank_24dp_E8EAED 2.svg"
import activeOrder from "assests/active-order.svg";
import activeTable from "assests/active-table.svg";
import activeCalendar from "assests/active-calendar.svg";
import calendarIcon from "assests/calendar_month_24dp_E8EAED 1.svg"
import tablesIcon from "assests/table_restaurant_24dp_E8EAED 2.svg"
import serveIcon from "assests/restaurant_24dp_E8EAED 1.svg"
import acitveServe from "assests/active-serve.svg"
import manage from "assests/Group.svg"
import activemanage from "assests/activemanage.svg"
import inventoryIcon from "assests/inventory-icon.svg"
import activeInventory from "assests/active-inventory-icon.svg"
import { getOrderTypePermissions, isPermissionAllowed } from "utils/function"
import { useGetSettingsQuery } from "pages/settings/ManageSettings/services"


const POSHeader = () => {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null)
  const [drawerOpen, setDrawerOpen] = useState(false)
  const isMenuOpen = Boolean(menuAnchorEl)
  const theme = useTheme();
  // ref for the logo+menu container
  const logoRef = useRef(null)

  // Get user data from Redux
  const userData = useSelector((state) => state?.posData)
  const token = userData?.token;
  const { data: settingsData } = useGetSettingsQuery(undefined, { skip: !token });
  const settings = settingsData?.data?.settings;

  const permissions = useMemo(() => getOrderTypePermissions(userData), [userData]);
  const isCalendarPermitted = isPermissionAllowed(permissions, 'permission_pos_calender_view') && isPermissionAllowed(permissions, 'permission_pos_calendar_view');
  const isInventoryPermitted = isPermissionAllowed(permissions, 'permission_pos_inventory');
  const isTableBookingAllowed = isPermissionAllowed(permissions, 'permission_table_booking');
  const isChefPanelPermitted = isPermissionAllowed(permissions, 'permission_pos_chef_panel');

  const isCalendarAllowed = isCalendarPermitted && (settings?.calendar !== undefined ? Boolean(settings.calendar === 1 || settings.calendar === "1" || settings.calendar === true) : true);
  const isInventoryAllowed = isInventoryPermitted && (settings?.inventory !== undefined ? Boolean(settings.inventory === 1 || settings.inventory === "1" || settings.inventory === true) : true);
  const isChefPanelAllowed = isChefPanelPermitted && (settings?.serve_panel !== undefined ? Boolean(settings.serve_panel === 1 || settings.serve_panel === "1" || settings.serve_panel === true) : true);

  const ImgIcon = (src, alt, width, height) => (
    <img
      src={src || "/placeholder.svg"}
      alt={alt}
      style={{
        width: width ? width : 20,
        height: height ? height :20,
        verticalAlign: "middle",
      }}
    />
  )

  const handleLogoClick = (event) => {
    setMenuAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setMenuAnchorEl(null)
  }

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      ((event).key === "Tab" ||
        (event).key === "Shift")
    ) {
      return
    }
    setDrawerOpen(open)
  }

  const navButtons = useMemo(() => {
    const list = [
      { icon: posIcon, activeIcon: posActiveIcon, label: 'POS', color: 'highlight', path: '/', activePaths: ['/'], },
      { icon: ordersIcon, activeIcon: activeOrder, label: 'Orders', color: 'secondary', path: '/orders' },
      { icon: calendarIcon, activeIcon: activeCalendar, label: 'Calendar', color: 'secondary', path: '/calendar' },
      { icon: tablesIcon, activeIcon: activeTable, label: 'Tables', color: 'secondary', path: '/tables' },
      { icon: serveIcon, activeIcon: acitveServe, label: 'Serve Panel', color: 'secondary', path: '/serve' },
      { icon: inventoryIcon, activeIcon: activeInventory, label: 'Inventory', color: 'secondary', path: '/inventory' },
      { icon: manage, activeIcon: activemanage,  label: 'Manage', color: 'secondary', path:'/manage-settings' },
    ];

    return list.filter((item) => {
      if (item.path === '/calendar' && !isCalendarAllowed) return false;
      if (item.path === '/inventory' && !isInventoryAllowed) return false;
      if (item.path === '/tables' && !isTableBookingAllowed) return false;
      if (item.path === '/serve' && !isChefPanelAllowed) return false;
      return true;
    });
  }, [isCalendarAllowed, isInventoryAllowed, isTableBookingAllowed, isChefPanelAllowed]);

  const navList = (
    <List className="nav-drawer">
      {navButtons?.map((item, index) => (
        <ListItem key={index} disablePadding>
          <Button
            fullWidth
            startIcon={ImgIcon(item.icon, item.label)}
            sx={{
              color: item.color,
              justifyContent: "flex-start",
              py: 1.5,
            }}
          >
            {item.label}
          </Button>
        </ListItem>
      ))}
    </List>
  )

  return (
    <POSHeaderContainer
        navList={navList}
        navButtons={navButtons}
        toggleDrawer={toggleDrawer}
        handleMenuClose={handleMenuClose}
        handleLogoClick={handleLogoClick}
        ImgIcon={ImgIcon}
        userData={userData}
        logoRef={logoRef}
        isMenuOpen={isMenuOpen}
        drawerOpen={drawerOpen}
    />
  );
}

export default React.memo(POSHeader);

